module.exports = __webpack_public_path__ + "static/media/Mark Schaffer Headshot_1618331751775.503f4897.png";